import { useCallback } from 'react';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import { useSidebar } from '@src/context/hooks';

import SidebarActionItem from './SidebarActionItem';
import SidebarContainer from './SidebarContainer';
import SidebarDrawer from './SidebarDrawer';
import SidebarGroup from './SidebarGroup';
import SidebarNavItem from './SidebarNavItem';

function Sidebar() {
  const sidebar = useSidebar();

  const handleOnToggle = useCallback(() => {
    sidebar.toggle();
  }, [sidebar]);

  return (
    <SidebarDrawer variant="permanent" open={!sidebar.isCollapsed} onClose={handleOnToggle}>
      <SidebarContainer>
        <SidebarGroup>
          {sidebar.items.top.map((item) => (
            <SidebarNavItem
              to={item.to}
              key={item.key}
              icon={item.icon}
              label={item.label}
            />
          ))}
        </SidebarGroup>

        <SidebarGroup>
          {sidebar.items.bottom.map((item) => (
            <SidebarNavItem
              to={item.to}
              key={item.key}
              icon={item.icon}
              label={item.label}
            />
          ))}
        </SidebarGroup>

        <SidebarGroup>
          <SidebarActionItem
            label="Hide Panel"
            icon={<ChevronLeftIcon />}
            onClick={handleOnToggle}
          />
        </SidebarGroup>
      </SidebarContainer>
    </SidebarDrawer>
  );
}

Sidebar.displayName = 'Sidebar';
export default Sidebar;
